/* tslint:disable */
/* eslint-disable */
/**
 * Watermap Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: srohr-luther@brita.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface BasicStageContent
 */
export interface BasicStageContent {
    /**
     * 
     * @type {string}
     * @memberof BasicStageContent
     */
    id?: string;
    /**
     * 
     * @type {User}
     * @memberof BasicStageContent
     */
    user?: User;
    /**
     * 
     * @type {string}
     * @memberof BasicStageContent
     */
    filename?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicStageContent
     */
    comments?: Array<string> | null;
    /**
     * 
     * @type {Date}
     * @memberof BasicStageContent
     */
    timestamp?: Date | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof BasicStageContent
     */
    countries?: { [key: string]: number; } | null;
    /**
     * 
     * @type {number}
     * @memberof BasicStageContent
     */
    acceptedLineCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BasicStageContent
     */
    rejectedLineCount?: number | null;
}

export function BasicStageContentFromJSON(json: any): BasicStageContent {
    return BasicStageContentFromJSONTyped(json, false);
}

export function BasicStageContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasicStageContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'filename': !exists(json, 'filename') ? undefined : json['filename'],
        'comments': !exists(json, 'comments') ? undefined : json['comments'],
        'timestamp': !exists(json, 'timestamp') ? undefined : (json['timestamp'] === null ? null : new Date(json['timestamp'])),
        'countries': !exists(json, 'countries') ? undefined : json['countries'],
        'acceptedLineCount': !exists(json, 'acceptedLineCount') ? undefined : json['acceptedLineCount'],
        'rejectedLineCount': !exists(json, 'rejectedLineCount') ? undefined : json['rejectedLineCount'],
    };
}

export function BasicStageContentToJSON(value?: BasicStageContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user': UserToJSON(value.user),
        'filename': value.filename,
        'comments': value.comments,
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp === null ? null : value.timestamp.toISOString()),
        'countries': value.countries,
        'acceptedLineCount': value.acceptedLineCount,
        'rejectedLineCount': value.rejectedLineCount,
    };
}


